module.exports = __webpack_public_path__ + "71219e962fcd9372f302d0f3b99a69fb.png";